/** F1-style points by finishing place (1st..6th). */
export const PLACE_POINTS = [10, 7, 5, 3, 2, 1] as const;
export const ACCURACY_BONUS = 2;

export function pointsForPlace(place: number): number {
  return PLACE_POINTS[place - 1] ?? 0;
}
